module.exports = __webpack_public_path__ + "static/media/peace.f4afc161.svg";